export default __webpack_public_path__ + "static/media/user-mng.2cb946d1.svg";